import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5c14d4a0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "scroll-wrap"
};
const _hoisted_2 = {
  class: "scrollbar-wrap"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "col-xl-2 pl-3 pr-3"
};
const _hoisted_5 = {
  class: "sticky-top text-center"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted"
}, "Share this", -1));

const _hoisted_7 = {
  class: "share d-inline-block"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "a2a_kit a2a_kit_size_32 a2a_default_style"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "a2a_dd",
  href: "https://www.addtoany.com/share"
}), /*#__PURE__*/_createElementVNode("a", {
  class: "a2a_button_facebook"
}), /*#__PURE__*/_createElementVNode("a", {
  class: "a2a_button_twitter"
})], -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-xl-8 border order-1",
  role: "main"
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "article-body"
}, "加载中")], -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sticky-top mr-1 toc-scroll",
  style: {
    "top": "90px"
  },
  id: "article-toc"
}, null, -1));

const _hoisted_11 = [_hoisted_10];
import { useScreenWidth } from "@/stores/screenWidth";
import axios from "axios";
import editormd from "editor.md/src/editormd";
import { onMounted, inject, computed, ref, watch, onDeactivated, onUnmounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from 'pinia';
export default {
  __name: 'BlogContent',
  props: {
    blogPath: {
      type: String,
      required: true
    },
    blogTitle: {
      type: String,
      required: true
    }
  },

  setup(__props) {
    const probs = __props;
    const route = useRoute();
    const router = useRouter();
    const globalParams = inject("globalParams");
    const editor = editormd();
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {// console.log(entry.target);
        }
      });
    });
    const smallSceenSize = globalParams.smallScreenSize;
    const first = ref("order-0");
    const second = ref("order-2");
    var getBlogContent = axios.get(probs.blogPath);
    const screenWidth = useScreenWidth();
    let preTitle = document.title;
    onMounted(() => {
      document.title = probs.blogTitle;
    });
    onUnmounted(() => {
      document.title = preTitle;
    });
    onMounted(() => {
      getBlogContent.then(res => {
        {
          let mdcontent = res.data;
          let el = document.getElementById("article-body");
          let tmp = probs.blogPath.split("/");
          let dirName = tmp[tmp.length - 1 - 1];
          mdcontent = mdcontent.replace(/\]\(assets/g, "](./assets/blogs/" + dirName + "/assets");
          el.innerHTML = "";
          mdcontent = mdcontent.trim().length > 0 ? mdcontent : "**等待填坑**";
          let md2html = new Promise(function (resolve, reject) {
            editor.markdownToHTML("article-body", {
              markdown: mdcontent,
              tocContainer: "#article-toc",
              tocDropown: true,
              tex: true // 默认不解析

            });
            resolve();
          });
          md2html.then(() => {
            const titleElments = document.querySelectorAll(".reference-link"); // https://www.qy.cn/jszx/detail/6411.html
            // 监听元素是否可见

            let tocContainer = document.querySelector(".markdown-toc-list");
            let liElements = tocContainer.getElementsByTagName("li");

            for (let i = 0; i < liElements.length; i++) {
              let el = liElements[i].firstChild;
              el.addEventListener("click", function (event) {
                event.preventDefault();
                titleElments[i].scrollIntoView({
                  behavior: "smooth"
                });
              });
              observer.observe(titleElments[i]);
            }

            let aElements = el.querySelectorAll("a");

            for (let aEl of aElements) {
              let href = aEl.getAttribute("href"); // href.length-1 对应最后一个

              if (href !== null && href.search(/.md/) == href.length - 3) {
                aEl.addEventListener("click", event => {
                  event.preventDefault();
                  let targetBlogName = href.split("./")[1];
                  let targetPath = route.params.path;
                  targetPath = targetPath.substring(0, targetPath.lastIndexOf("/") + 1) + targetBlogName;
                  let targetParams = route.params;
                  targetParams.path = targetPath;
                  targetParams.blogName = targetBlogName;
                  let targetRouter = router.resolve({
                    query: {
                      blogName: targetBlogName,
                      path: targetPath
                    }
                  });
                  window.open(targetRouter.href);
                });
              }
            }
          });
        }
      });
    });
    onBeforeUnmount(() => {
      document.querySelector('#article-body').innerHTML = "加载中";
      document.querySelector('#article-toc').innerHTML = '';
      console.log("博客详细页面将要卸载");
      observer.disconnect();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "https://static.addtoany.com/menu/page.js",
        async: ""
      }))])])]), _hoisted_9, _createElementVNode("div", {
        class: _normalizeClass(["col-md-2 pl-3", _unref(screenWidth) <= 1200 ? first.value : second.value]),
        id: "div-article-toc"
      }, _hoisted_11, 2), (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        src: "./assets/js/MathJaxConfig.js"
      }))])])]);
    };
  }

};